import { firestore } from "./Firebase";

const levelsRef = firestore.collection("levels");
const listsRef = firestore.collection("lists");
const gamesRef = firestore.collection("games");

export const readLevels = async id => {
  return levelsRef
    .where("id", "==", +id)
    .get()
    .then(snapshot => {
      let response;
      snapshot.forEach(doc => {
        response = doc.data();
      });
      return response;
    });
};

export const readLists = async () => {
  return listsRef
    .where("id", "==", 1)
    .get()
    .then(snapshot => {
      let response;
      snapshot.forEach(doc => {
        response = doc.data();
      });
      return response;
    });
};

export const updateLists = async data => {
  return await listsRef
    .where("id", "==", 1)
    .get()
    .then(function(querySnapshot) {
      querySnapshot.forEach(function(doc) {
        listsRef.doc(doc.id).update({ data });
      });
    });
};

export const moveWordToLevel = async (levelID, nextLevelID, word) => {
  // remove
  await levelsRef
    .where("id", "==", levelID)
    .get()
    .then(function(querySnapshot) {
      querySnapshot.forEach(function(doc) {
        const levelWords = doc.data().words;
        levelsRef
          .doc(doc.id)
          .update({ words: levelWords.filter(w => w.id !== word.id) });
      });
    });

  //add
  return await levelsRef
    .where("id", "==", nextLevelID)
    .get()
    .then(function(querySnapshot) {
      querySnapshot.forEach(function(doc) {
        const levelWords = doc.data().words;
        levelsRef.doc(doc.id).update({ words: [...levelWords, word] });
      });
    });
};

export const updateLevel = async (levelID, newWords) => {
  return await levelsRef
    .where("id", "==", levelID)
    .get()
    .then(function(querySnapshot) {
      querySnapshot.forEach(function(doc) {
        levelsRef.doc(doc.id).update({ words: newWords });
      });
    });
};

export const getAllData = async () => {
  return levelsRef.get().then(snapshot => {
    let response = [];
    snapshot.forEach(doc => {
      response.push(doc.data());
    });
    const sorted = response
      .sort((a, b) => {
        return a.id - b.id;
      })
      .map(level => ({
        ...level,
        words: level.words.sort((a, b) => {
          return a.id - b.id;
        })
      }));
    return JSON.stringify(sorted);
  });
};

export const readGames = async language => {
  return gamesRef
    .where("language", "==", language)
    .get()
    .then(snapshot => {
      let response;
      snapshot.forEach(doc => {
        response = doc.data();
      });
      return response;
    });
};

export const updateGames = async (language, games) => {
  return await gamesRef
    .where("language", "==", language)
    .get()
    .then(function(querySnapshot) {
      querySnapshot.forEach(function(doc) {
        gamesRef.doc(doc.id).update({ games });
      });
    });
};



// WEBPACK FOOTER //
// ./src/helpers/api.js